export default "__VITE_ASSET__BTCCePxy__"